module.exports = __webpack_public_path__ + "static/media/no-wifi-internet-connection-img.537d2415.png";